<template>
    <div>
        <div>
            <div id="modal-access-team" class="modal fade" role="dialog">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            Select access right for {{
                                `${selectedTeam.index != -1 ?
                                    searchResults[selectedTeam.index].name : ''}`
                            }}
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="">
                                <b-container>
                                    <b-row>
                                        <b-col v-if="accessRightTeam.free_trial" cols="6">
                                            <b-row>
                                                <b-col cols="10">
                                                    <label>
                                                        Convert to Customer & Clear Data
                                                    </label>
                                                </b-col>
                                                <b-col cols="2">
                                                    <b-form-checkbox switch size="lg" id="ClearDummyData"
                                                                     v-model="accessRightTeam.clear_dummy_data" @change="handleClearDummyDataChange"/>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col cols="10">
                                                    <label>
                                                        Convert to Customer & Keep Data
                                                    </label>
                                                </b-col>
                                                <b-col cols="2">
                                                    <b-form-checkbox switch size="lg" id="convertToCustomer"
                                                                     v-model="accessRightTeam.convert_to_customer" @change="handleConvertToCustomerChange"/>
                                                </b-col>
                                            </b-row>

                                        </b-col>
                                        <b-col v-else cols="6"></b-col>
                                        <b-col cols="3" class="text-right">
                                            <label for="platform">
                                                Platform
                                            </label>
                                        </b-col>
                                        <b-col cols="3">
                                            <select name="platform" id="platform" class="form-control"
                                                    v-model="accessRightTeam.platform">
                                                <option value="construction">Construction</option>
                                                <option value="sales">Sales</option>
                                            </select>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6">
                                            <h4 class="mb-2 text-dark">Plan</h4>
                                            <div class="ml-4">
                                                <b-row v-for="plan in plans" :key="plan.id">
                                                    <b-col cols="8">
                                                        <label :for="'plan-'+plan.name">
                                                            {{ plan.name }}
                                                        </label>
                                                    </b-col>
                                                    <b-col cols="4">
                                                        <b-form-checkbox switch size="lg" :id="'plan-'+plan.name"
                                                                       v-model="planStates[plan.name]" @change="selectPlan(plan)" />
                                                    </b-col>
                                                </b-row>
                                            </div>


                                            <h4 class="mb-2 mt-3 text-dark">Add ons</h4>
                                            <div class="ml-4">
                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="project-management-switch">
                                                            Project Management
                                                        </label>
                                                    </b-col>
                                                    <b-col cols="4">
                                                        <b-form-checkbox switch size="lg" id="project-management-switch"
                                                                         v-model="accessRightTeam.management"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="propostal_generator">
                                                            Proposal Generator
                                                        </label>
                                                    </b-col>

                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="propostal_generator"
                                                                         v-model="accessRightTeam.proposalGenerator"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="calendar">
                                                            Calendar
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="calendar"
                                                                         v-model="accessRightTeam.calendar"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="api">
                                                            API
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="api"
                                                                         v-model="accessRightTeam.api"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="offices">
                                                            Limit offices to 1
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="offices"
                                                                         v-model="accessRightTeam.offices"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="sequences">
                                                            Sequences
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="sequences"
                                                                         v-model="accessRightTeam.sequences"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="required_fields">
                                                            Required Fields
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="required_fields"
                                                                         v-model="accessRightTeam.required_fields"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="scheduled_reports">
                                                            Scheduled Reports
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="scheduled_reports"
                                                                         v-model="accessRightTeam.scheduled_reports"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="automations">
                                                            Automations
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="automations"
                                                                         v-model="accessRightTeam.automations"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="share_company">
                                                            Shared Companies
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="share_company"
                                                                         v-model="accessRightTeam.share_company"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="bulk_emails">
                                                            Bulk Emails
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="bulk_emails"
                                                                         v-model="accessRightTeam.bulk_emails"/>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="reorder_and_hide">
                                                            Reorder/Hide Labels
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="reorder_and_hide" v-model="accessRightTeam.reorder_and_hide"/>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="pricing">
                                                            Pricing
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="pricing" v-model="accessRightTeam.pricing"/>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="qrvey_access">
                                                            Custom Reports(Qrvey)
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="qrvey_access" v-model="accessRightTeam.has_qrvey_access"/>
                                                    </b-col>
                                                </b-row>
                                            </div>


                                        </b-col>
                                        <b-col cols="6">
                                            <h4 class="mb-2 mt-2 text-dark">Integrations</h4>

                                            <div class="ml-4">
                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="estimating-edge-switch">
                                                            Estimating Edge
                                                        </label>
                                                    </b-col>
                                                    <b-col cols="4">
                                                        <b-form-checkbox switch size="lg" id="estimating-edge-switch"
                                                                         v-model="accessRightTeam.estimatingEdge"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="fcs">
                                                            FCS
                                                        </label>
                                                    </b-col>

                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="fcs"
                                                                         v-model="accessRightTeam.fcs"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="roof_chief">
                                                            Roof Chief
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="roof_chief"
                                                                         v-model="accessRightTeam.roofChief"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="blackbox">
                                                            Blackbox
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="blackbox"
                                                                         v-model="accessRightTeam.blackbox"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="zapier">
                                                            Zapier
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="zapier"
                                                                         v-model="accessRightTeam.zapier"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="hh2">
                                                            HH2
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="hh2"
                                                                         v-model="accessRightTeam.hh2"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="dataforma">
                                                            DataForma
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="dataforma"
                                                                         v-model="accessRightTeam.dataForma"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="stack">
                                                            Stack
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="stack"
                                                                         v-model="accessRightTeam.stack"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="company_cam">
                                                            Company Cam
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="company_cam"
                                                                         v-model="accessRightTeam.company_cam"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="procore">
                                                            Procore
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="procore"
                                                                         v-model="accessRightTeam.procore"/>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="hover">
                                                            Hover
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="hover"
                                                                         v-model="accessRightTeam.hover"/>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="erp_integration">
                                                            ERP Integration
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="erp_integration"
                                                                         v-model="accessRightTeam.erp_integration"/>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="xscope">
                                                            XScope Integration
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="xscope"
                                                                         v-model="accessRightTeam.xscope"/>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="xscope">
                                                            QuickBooks Integration
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="quickBook"
                                                                         v-model="accessRightTeam.quickBook"/>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col cols="8">
                                                        <label for="hailRecon">
                                                            Hail Recon
                                                        </label>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-checkbox switch size="lg" id="hailRecon"
                                                                         v-model="accessRightTeam.hailRecon"/>
                                                    </b-col>
                                                </b-row>
                                            </div>

                                        </b-col>
                                    </b-row>
                                    <b-row v-if="accessRightTeam.has_qrvey_access">
                                        <p class="col-md-12  mt-3 mb-1 text-dark">Qrvey Data Sync Schedule</p>
                                        <div class="row mx-2 w-100">
                                            <!-- Frequency Dropdown -->
                                            <div class="col-md-3">
                                                <label>Frequency</label>
                                                <select v-model="qrvey_sync.frequency" class="form-control">
                                                    <option value="Minutes">Minutes</option>
                                                    <option value="Hours">Hours</option>
                                                    <option value="Daily">Daily</option>
                                                </select>
                                            </div>
                                            <!-- Every (Interval) Dropdown -->
                                            <div class="col-md-3">
                                                <label>Every</label>
                                                <select v-model="qrvey_sync.every" class="form-control">
                                                    <option v-for="n in frequencyIntervals(qrvey_sync.frequency)" :key="n" :value="n">
                                                        {{ n }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div v-if="qrvey_sync.frequency === 'Daily'" class="col-md-3">
                                                <label>Hour (UTC)</label>
                                                <multiselect
                                                    v-model="qrvey_sync.hours"
                                                    :options="hourOptions()"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    placeholder="Select hours"
                                                    label="label"
                                                    track-by="value"
                                                />
                                            </div>
                                            <!-- Hours and Minutes Selection (Only for Minutes/Hours Frequency) -->
                                            <div v-if="qrvey_sync.frequency !== 'Minutes'" class="col-md-3">
                                                <label>Minute after the Hour</label>
                                                <select v-model="qrvey_sync.minute" class="form-control">
                                                    <option v-for="minute in 60" :key="minute-1" :value="minute-1">
                                                        {{ minute-1 }}
                                                    </option>
                                                </select>
                                            </div>

                                        </div>
                                    </b-row>
                                </b-container>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-defualt" @click="closePermissionAccessForm()">Close</button>
                            <button class="btn btn-primary" @click="updateAccessTeam">Save changes</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div>
            <div id="modal-currency-format" class="modal fade" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            Change Currency format
                        </div>
                        <div class="modal-body">

                            <form>
                                <select class="form-control" v-model="selectedCurrencyFormat">
                                    <option v-for="(format, idx) in currencyFormats" :key="idx" :value="format">
                                        {{ format }}
                                    </option>
                                </select>
                            </form>

                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-defualt" @click="closeModalCurrency">Close</button>
                            <button class="btn btn-primary" @click="updateCurrencyFormat">Save changes</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <div id="modal-change-owner" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        Ownership Change
                    </div>
                    <div class="modal-body">
                        <form action="">
                            <div class="container">
                                <div class="form-group row">
                                    <div class="col col-md-4 col-form-label text-md-right">
                                        Owner
                                    </div>
                                    <div class="col col-md-6">
                                        <multiselect
                                            v-model="selectedUser"
                                            label="name"
                                            :show-labels="false"
                                            track-by="id"
                                            value="id"
                                            :options="users"
                                        ></multiselect>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-defualt" @click="closeModalOwnerForm()">Close</button>
                        <button class="btn btn-primary" @click="updateOwnerTeam">Change Owner</button>
                    </div>
                </div>

            </div>
        </div>

        <div id="modal-block-team" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        Account Access
                    </div>
                    <div class="modal-body d-flex justify-content-center">
                        <button class="btn btn-primary" @click="updateLockedTeam(!locked)">{{ (locked === 0 || locked === false) ? 'Lock' : 'Unlock' }}</button>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-defualt" @click="closeModalBlock()">Close</button>
                    </div>
                </div>

            </div>
        </div>

        <div class="card card-default kiosk-team-register">
            <div class="card-header">Invite Team</div>

            <div class="card-body">

                <div class="alert alert-success" v-if="teamInvitationMessage">
                    The team has been invited!
                </div>

                <form role="form">
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">Team Name</label>

                        <div class="col-md-6">
                            <input type="text" class="form-control" name="team" v-model="form.team"
                                   :class="{'is-invalid': form.errors.has('team')}">
                            <span class="invalid-feedback" v-show="form.errors.has('team')">
                                {{ form.errors.get('team') }}
                            </span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">Contact Name</label>

                        <div class="col-md-6">
                            <input type="text" class="form-control" name="contact" v-model="form.contact"
                                   :class="{'is-invalid': form.errors.has('contact')}">
                            <span class="invalid-feedback" v-show="form.errors.has('contact')">
                                {{ form.errors.get('contact') }}
                            </span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">E-Mail Address</label>

                        <div class="col-md-6">
                            <input type="email" class="form-control" name="email" v-model="form.email"
                                   :class="{'is-invalid': form.errors.has('email')}">
                            <span class="invalid-feedback" v-show="form.errors.has('email')">
                                {{ form.errors.get('email') }}
                            </span>
                        </div>
                    </div>

                    <div class="form-group row free-trial-toggle">
                        <label class="col-md-4 col-form-label text-md-right"></label>
                        <div class="col-md-6">
                            <b-form-checkbox name="check-button" v-model="form.isFreeTrial" id="systemSetupTypeSwitch" class="inline-block" switch></b-form-checkbox>
                            <label for="systemSetupTypeSwitch" class="inline-block">Free Trial Team</label>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center">
                        <div class="form-group pr-3 row mb-0">
                            <div class="col-md-12">
                                <button type="submit" class="btn btn-primary"
                                        @click.prevent="register"
                                        :disabled="registerTeamLoader">

                                <span v-if="registerTeamLoader">
                                    <i class="fa fa-btn fa-spinner fa-spin"></i> Registering
                                </span>

                                    <span v-else>
                                    Register Team
                                </span>
                                </button>
                            </div>
                        </div>
                        <div class="form-group row mb-0 invite-team-btn">
                            <div class="col-md-12">
                                <button type="submit" class="btn btn-primary"
                                        @click.prevent="send"
                                        :disabled="inviteTeamLoader">

                                <span v-if="inviteTeamLoader">
                                    <i class="fa fa-btn fa-spinner fa-spin"></i> inviting
                                </span>

                                    <span v-else>
                                    Invite Team
                                </span>
                                </button>
                            </div>
                        </div>
                    </div>

                </form>

            </div>
        </div>

        <div class="card card-default" style="border: 0;">
            <div class="card-header">Search Team</div>
            <div class="card-body">
                <form role="form" @submit.prevent>
                    <input type="text" id="kiosk-users-search" class="form-control"
                           name="search"
                           placeholder="Search by Name..."
                           v-model="searchForm.query"
                           @keyup.enter="search">
                </form>
            </div>
        </div>

        <div class="card card-default" v-if="searching">
            <div class="card-header">Search Results</div>

            <div class="card-body">
                <i class="fa fa-btn fa-spinner fa-spin"></i> Searching
            </div>
        </div>

        <div class="card card-default" v-if="!searching && noSearchResults">
            <div class="card-header">Search Results</div>

            <div class="card-body">
                No users matched the given criteria.
            </div>
        </div>

        <div class="card card-default" v-if="!searching && searchResults.length > 0">
            <div class="card-header">Search Results</div>

            <div class="table-responsive">
                <table class="table table-valign-middle mb-0">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Owner</th>
                        <th class="th-fit"></th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="(team, idx) in searchResults" :key="idx">
                        <td>
                            {{ team.name }}
                            <span class="px-1 py-px rounded-lg  tracking-wide ml-2 text-xs "
                                  :class="{'bg-blue-lighter text-blue-dark' : team.access.platform === 'construction' ,
                            'bg-green-lighter text-green-dark' : team.access.platform === 'sales'}">
                                {{ team.access.platform }}
                            </span>
                        </td>

                        <td>
                            <div>
                                {{ getSafe(() => team.owner.name) }}
                            </div>
                            <small class="text-muted">{{ getSafe(() => team.owner.email) }}</small>
                        </td>

                        <td>
                            <div class="btn-group">
                                <a href="#" class="btn btn-outline-danger"
                                   v-if="team.access.free_trial"
                                   @click.prevent="deleteTeam(team.id, idx)">
                                    <h5>
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </h5>
                                </a>
                                <a href="#" class="btn"
                                   :class="(team.locked === 0 || team.locked === false) ? 'btn-outline-primary' : 'btn-outline-danger'"
                                   @click.prevent="blockTeam(team.id, idx)">
                                    <h5>
                                        <i class="fa fa-lock" aria-hidden="true"></i>
                                    </h5>
                                </a>
                                <a href="#" class="btn btn-outline-primary"
                                   @click.prevent="updateCurrencyFormatModal(team.id, idx)">
                                    <h5>
                                        <i class="fa fa-map-marker" aria-hidden="true"></i>
                                    </h5>
                                </a>
                                <a href="#" class="btn btn-warning" @click.prevent="AccessTeamForm(team.id, idx)">
                                    <h5>
                                        <i class="fa fa-plus-square-o" aria-hidden="true"></i>
                                    </h5>
                                </a>
                                <a href="#" class="btn btn-primary" @click.prevent="changeOwnerForm(team.id, idx)">
                                    <i class="fa fa-exchange"></i>
                                </a>
                                <a :class="{ 'disabled' : !team.owner}" :href="'/spark/kiosk#/users/' + getSafe(() => team.owner.id)" class="btn btn-default">
                                    <i class="fa fa-search"></i>
                                </a>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <team-invites ></team-invites>
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import TeamInvites from "./team-invites";
import Swal from "sweetalert2";
import axios from "axios";

export default {
    name: 'teams',
    props: ['currency-formats'],
    data: () => ({
        locked:false,
        form: new SparkForm({
            team: '',
            contact: '',
            email: '',
            isFreeTrial: false
        }),
        searching: false,
        noSearchResults: false,
        searchResults: [],
        searchForm: new SparkForm({
            query: ''
        }),
        selectedTeam: {
            id: 0,
            index: -1
        },
        accessRightTeam: {
            platform: 'construction',
            management: false,
            estimatingEdge: false,
            proposalGenerator: false,
            fcs: false,
            roofChief: false,
            blackbox: false,
            zapier: false,
            hh2: false,
            calendar: false,
            dataForma: false,
            stack: false,
            company_cam: false,
            erp_integration: false,
            procore: false,
            api:false,
            offices:false,
            sequences: false,
            required_fields:false,
            hover:false,
            scheduled_reports:false,
            automations:false,
            share_company:false,
            bulk_emails:false,
            reorder_and_hide:false,
            pricing:false,
            xscope: false,
            free_trial: false,
            clear_dummy_data: false,
            convert_to_customer: false,
            quickBook: false,
            hailRecon: false,
            has_qrvey_access: false,
        },
        selectedCurrencyFormat: null,
        selectedUser: null,
        users: [],
        plans: [],
        planStates: {},
        selectedPlan: null,
        teamInvitationMessage: null,
        inviteTeamLoader: false,
        registerTeamLoader: false,
        qrvey_sync: {
            frequency: 'Hours',
            every: 4,
            hours: [],
            minute: 0,
        }
    }),
    components: {
        TeamInvites,
        Multiselect
    },
    watch: {
        'form.isFreeTrial': {
            handler(newValue, oldValue) {
                let element = $('.invite-team-btn');
                newValue ? element.hide() : element.show();
            }
        }
    },
    computed: {
        user() {
            return this.$root.user;
        }
    },
    mounted() {
            // console.log('accessRightTeam',this.accessRightTeam);
        this.fetchPlans()
    },

    methods: {
        fetchPlans(){
            axios.get(route('spark.kiosk.plans.list'))
                .then(response => {
                    this.plans = response.data;
                    response.data.forEach(item => {
                        this.planStates = Object.assign(this.planStates, {[item.name]: false})
                    })
                });
        },
        selectPlan(plan){
            let self = this;
            self.planStates = _.mapValues(self.planStates, () => false)
            self.planStates[plan.name] = true;
            self.selectedPlan = plan;
            self.accessRightTeam.plan_id = plan.id;

            this.setPlanAccessRight(plan)
        },
        search() {
            this.searching = true;
            this.noSearchResults = false;
            this.selectedTeam = {id: 0,index: -1};

            axios.post(route('spark.kiosk.team.search'), this.searchForm)
                .then(response => {
                    this.searchResults = response.data.data;
                    this.noSearchResults = this.searchResults.length === 0;

                    this.searching = false;
                });
        },
        send() {
            let self = this;
            self.inviteTeamLoader = true;
            Spark.post(route('spark.kiosk.team.send'), this.form)
                .then((res) => {
                    self.inviteTeamLoader = false;
                    if(res.status === 'success'){
                        this.form.team = '';
                        this.form.contact = '';
                        this.form.email = '';
                        this.teamInvitationMessage = true;
                        setTimeout(() => {
                            this.teamInvitationMessage = false
                        }, 2000)

                        this.confirmationToast('Success!', res.message, 'success')
                    }else{
                        this.confirmationToast('Warning!', res.message, 'warning')
                    }


                })
                .catch((err) => {
                    self.inviteTeamLoader = false;
                    this.confirmationToast('An error occurred!', err.message, 'error')
                });
        },
        fetchTeamUsers(teamId, idx) {
            return new Promise((resolve, reject) => {
                axios.get(route('spark.kiosk.team.users', {team: teamId})).then(({data}) => {
                    this.users = data;
                    this.selectedUser = this.users.find(user => user.pivot.role === 'owner');
                    resolve();
                })
            });
        },
        async changeOwnerForm(teamId, idx) {
            await this.fetchTeamUsers(teamId);
            this.selectedTeam.id = teamId;
            this.selectedTeam.index = idx;
            $("#modal-change-owner").modal("show");
        },
        updateOwnerTeam() {
            axios.post(route('spark.kiosk.team.change-owner', {team: this.selectedTeam.id}), {user_id: this.selectedUser.id}).then(({data}) => {
                this.searchResults[this.selectedTeam.index].owner = {
                    email: this.selectedUser.email,
                    name: this.selectedUser.name,
                    id: this.selectedUser.id
                };
                this.closeModalOwnerForm();
            });
        },
        AccessTeamForm(teamId, idx) {
            this.selectedTeam.id = teamId;
            this.selectedTeam.index = idx;
            this.planStates = _.mapValues(this.planStates, () => false)
            this.selectedPlan = this.plans.find(x => x.id === this.searchResults[idx].access.plan_id) ?? null

            if(this.selectedPlan) {
                this.planStates[this.selectedPlan.name] = true;
            }
            this.setAccessRight(this.searchResults[idx].access);
            $("#modal-access-team").modal("show");
        },
        updateAccessTeam() {
            axios.post(route('spark.kiosk.team.permission-access', {team: this.selectedTeam.id}),
                {
                    platform: this.accessRightTeam.platform,
                    has_management_access: this.accessRightTeam.management,
                    has_estimating_edge_access: this.accessRightTeam.estimatingEdge,
                    has_proposal_generator_access: this.accessRightTeam.proposalGenerator,
                    has_fcs_access: this.accessRightTeam.fcs,
                    has_roof_chief_access: this.accessRightTeam.roofChief,
                    has_blackbox_access: this.accessRightTeam.blackbox,
                    has_zapier_access: this.accessRightTeam.zapier,
                    has_hh2_access: this.accessRightTeam.hh2,
                    has_api_access: this.accessRightTeam.api,
                    has_calendar_access: this.accessRightTeam.calendar,
                    has_dataforma_access: this.accessRightTeam.dataForma,
                    has_stack_access: this.accessRightTeam.stack,
                    has_company_cam_access: this.accessRightTeam.company_cam,
                    has_erp_integration_access: this.accessRightTeam.erp_integration,
                    has_procore_access: this.accessRightTeam.procore,
                    has_offices_access: this.accessRightTeam.offices,
                    has_sequences_access: this.accessRightTeam.sequences,
                    has_required_fields_access: this.accessRightTeam.required_fields,
                    has_hover_access: this.accessRightTeam.hover,
                    has_scheduled_reports_access: this.accessRightTeam.scheduled_reports,
                    has_automations_access: this.accessRightTeam.automations,
                    has_share_company_access: this.accessRightTeam.share_company,
                    has_bulk_email_access: this.accessRightTeam.bulk_emails,
                    plan_id: this.accessRightTeam.plan_id,
                    bulk_emails_limit: this.accessRightTeam.bulk_emails_limit,
                    automations_limit: this.accessRightTeam.automations_limit,
                    has_reorder_and_hide_access: this.accessRightTeam.reorder_and_hide,
                    has_pricing_access: this.accessRightTeam.pricing,
                    has_xscope_access: this.accessRightTeam.xscope,
                    is_free_trial: this.accessRightTeam.free_trial ? ((this.accessRightTeam.clear_dummy_data || this.accessRightTeam.convert_to_customer) ? false: this.accessRightTeam.free_trial) : false ,
                    clear_dummy_data: this.accessRightTeam.clear_dummy_data,
                    convert_to_customer: this.accessRightTeam.convert_to_customer,
                    has_quick_book_access: this.accessRightTeam.quickBook,
                    has_hail_recon: this.accessRightTeam.hailRecon,
                    has_qrvey_access: this.accessRightTeam.has_qrvey_access,
                    qrvey_sync_settings: this.accessRightTeam.has_qrvey_access? this.toCron(this.qrvey_sync) : null,
                    qrvey_sync: this.qrvey_sync ?? null
                }
            ).then(({data}) => {
                this.searchResults[this.selectedTeam.index].access = data.access;
                if(data.access?.qrvey_sync){
                    this.qrvey_sync = data.access.qrvey_sync
                }
                this.closePermissionAccessForm();
            });
        },
        blockTeam(teamId, idx) {
            this.selectedTeam.id = teamId;
            this.selectedTeam.index = idx;
            this.setTeamLocked(this.searchResults[idx]);
            $('#modal-block-team').modal("show");
        },
        updateCurrencyFormatModal(team, idx) {
            this.selectedTeam.id = team;
            this.selectedTeam.index = idx;
            this.selectedCurrencyFormat = this.searchResults[idx].currency;
            $('#modal-currency-format').modal("show");
        },
        updateCurrencyFormat() {
            let self = this;
            axios.put(route('spark.kiosk.team.currency-format', {team: this.selectedTeam.id}), {format: this.selectedCurrencyFormat}).then(() => {
                self.searchResults[self.selectedTeam.index].currency = self.selectedCurrencyFormat;
                self.closeModalCurrency();
            });
        },
        updateLockedTeam() {
            let self = this;
            self.locked = !self.locked;
            axios.put(route('spark.kiosk.team.update-locked', {team: this.selectedTeam.id}), {locked: this.locked}).then(() => {
                self.searchResults[self.selectedTeam.index].locked = self.locked;
                self.closeModalBlock();
            });
        },
        setAccessRight(access) {
            this.accessRightTeam.platform = access.platform;
            this.accessRightTeam.management = access.management === 1;
            this.accessRightTeam.estimatingEdge = access.estimating_edge === 1;
            this.accessRightTeam.proposalGenerator = access.proposal_generator === 1;
            this.accessRightTeam.fcs = access.fcs === 1;
            this.accessRightTeam.roofChief = access.roof_chief === 1;
            this.accessRightTeam.blackbox = access.blackbox === 1;
            this.accessRightTeam.zapier = access.zapier === 1;
            this.accessRightTeam.hh2 = access.hh2 === 1;
            this.accessRightTeam.api = access.api === 1;
            this.accessRightTeam.calendar = access.calendar === 1;
            this.accessRightTeam.dataForma = access.dataForma === 1;
            this.accessRightTeam.stack = access.stack === 1;
            this.accessRightTeam.company_cam = access.company_cam === 1;
            this.accessRightTeam.erp_integration = access.erp_integration === 1;
            this.accessRightTeam.procore = access.procore === 1;
            this.accessRightTeam.offices = access.offices === 1;
            this.accessRightTeam.sequences = access.sequences === 1;
            this.accessRightTeam.required_fields = access.required_fields === 1;
            this.accessRightTeam.hover = access.hover === 1;
            this.accessRightTeam.scheduled_reports = access.scheduled_reports === 1;
            this.accessRightTeam.automations = access.automations === 1;
            this.accessRightTeam.share_company = access.share_company === 1;
            this.accessRightTeam.bulk_emails = access.bulk_emails === 1;
            this.accessRightTeam.plan_id = access.plan_id ?? null;
            this.accessRightTeam.bulk_emails_limit = access.bulk_emails_limit;
            this.accessRightTeam.automations_limit = access.automations_limit;
            this.accessRightTeam.reorder_and_hide = access.reorder_and_hide === 1;
            this.accessRightTeam.pricing = access.pricing === 1;
            this.accessRightTeam.xscope = access.xscope === 1;
            this.accessRightTeam.free_trial = access.free_trial === 1;
            this.accessRightTeam.clear_dummy_data = access.clear_dummy_data === 1 ? null : false;
            this.accessRightTeam.convert_to_customer =  !access.free_trial === 1;
            this.accessRightTeam.quickBook = access.quickBook === 1;
            this.accessRightTeam.hailRecon = access.hailRecon === 1;
            this.accessRightTeam.has_qrvey_access = access.qrvey === 1;
            if(access.qrvey_sync){
                this.qrvey_sync = access.qrvey_sync;
            }else{
                this.qrvey_sync = {
                    frequency: 'Hours',
                    every: 4,
                    hours: [],
                    minute: 0,
                }
            }
        },
        setPlanAccessRight(plan) {
            const options = JSON.parse(plan.options);
            const addOns = options.add_ons;
            const integrations = options.integrations;
            this.accessRightTeam.management = addOns.management;
            this.accessRightTeam.estimatingEdge = integrations.estimatingEdge;
            this.accessRightTeam.proposalGenerator = addOns.proposalGenerator;
            this.accessRightTeam.fcs = integrations.fcs;
            this.accessRightTeam.roofChief = integrations.roofChief;
            this.accessRightTeam.blackbox = integrations.blackbox;
            this.accessRightTeam.zapier = integrations.zapier;
            this.accessRightTeam.hh2 = integrations.hh2;
            this.accessRightTeam.api = addOns.api;
            this.accessRightTeam.calendar = addOns.calendar;
            this.accessRightTeam.dataForma = integrations.dataForma;
            this.accessRightTeam.stack = integrations.stack;
            this.accessRightTeam.company_cam = integrations.company_cam;
            this.accessRightTeam.erp_integration = integrations.erp_integration;
            this.accessRightTeam.procore = integrations.procore;
            this.accessRightTeam.offices = addOns.offices;
            this.accessRightTeam.sequences = addOns.sequences;
            this.accessRightTeam.required_fields = addOns.required_fields;
            this.accessRightTeam.hover = integrations.hover;
            this.accessRightTeam.scheduled_reports = addOns.scheduled_reports;
            this.accessRightTeam.automations = addOns.automations;
            this.accessRightTeam.share_company = addOns.share_company;
            this.accessRightTeam.bulk_emails = addOns.bulk_emails;
            this.accessRightTeam.bulk_emails_limit = options.bulk_emails_limit;
            this.accessRightTeam.automations_limit = options.automations_limit;
            this.accessRightTeam.reorder_and_hide = addOns.reorder_and_hide;
            this.accessRightTeam.pricing = addOns.pricing;
            this.accessRightTeam.xscope = integrations.xscope;
            this.accessRightTeam.quickBook = integrations.quickBook;
            this.accessRightTeam.hailRecon = integrations.hailRecon;
            this.accessRightTeam.has_qrvey_access = addOns.qrvey;
        },
        setTeamLocked(team) {
            this.locked = team.locked;
        },
        closePermissionAccessForm() {
            $("#modal-access-team").modal("hide");
        },
        closeModalOwnerForm() {
            $("#modal-change-owner").modal("hide");
        },
        closeModalCurrency() {
            $("#modal-currency-format").modal("hide");
        },
        closeModalBlock() {
            $("#modal-block-team").modal("hide");
        },
        deleteTeam(teamId, idx) {
            this.selectedTeam.id = teamId;
            this.selectedTeam.index = idx;
            let self = this;

            Swal.fire({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this team!",
                icon: "warning",
                buttons: true,
                showCancelButton: true,
                confirmButtonColor: 'red',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    axios.delete(route('spark.kiosk.team.delete', self.selectedTeam)).then(({data}) => {
                        if(data.status == 'success') {
                            self.getToast(2500).fire({
                                type: data.status,
                                title: data.message
                            });
                        }else{
                            self.getToast(2500).fire({
                                type: 'warning',
                                title: 'Something went wrong try again later'
                            });
                        }
                    })
                }
            });
        },
        handleClearDummyDataChange() {
            this.$nextTick(() => {
                if (this.accessRightTeam.clear_dummy_data) {
                    this.accessRightTeam.convert_to_customer = false;
                }
            })
        },
        handleConvertToCustomerChange() {
            this.$nextTick(() => {
                if (this.accessRightTeam.convert_to_customer) {
                    this.accessRightTeam.clear_dummy_data = false;
                }
            })

        },
        register() {
            let self = this;
            self.registerTeamLoader = true;
            Spark.post(route('spark.kiosk.team.register'), self.form)
                .then((res) => {
                    self.registerTeamLoader = false;
                    let teamName = self.form.team;
                    self.form.reset();
                    self.confirmationToast('Register', teamName + ' team has been registered.', 'success')
                })
                .catch((err) => {
                    self.registerTeamLoader = false;
                });
        },
        hourOptions() {
            return Array.from({length: 24}, (_, i) => ({
                label: i === 0 ? '12 AM' : (i < 12 ? i + ' AM' : (i === 12 ? '12 PM' : (i-12) + ' PM')),
                value: i
            }));
        },
        frequencyIntervals(freq) {
            if (freq === 'Minutes') {
                // 1-59
                return Array.from({length: 59}, (_, i) => i + 1);
            } else if (freq === 'Hours') {
                // Like your screenshot
                return [1, 2, 3, 4, 6, 12];
            } else if (freq === 'Daily') {
                return [1,2,3,4,5,6]; // Always 1 (every day), you can omit if you want
            }
            return [1];
        },
        toCron(qrvey_sync) {
            if (qrvey_sync.frequency === 'Minutes') {
                return `0/${qrvey_sync.every} * * * ? *`;
            }
            else if (qrvey_sync.frequency === 'Hours') {
                return `${qrvey_sync.minute || 0} 0/${qrvey_sync.every} * * ? *`;
            }
            else if (qrvey_sync.frequency === 'Daily') {
                let dayStr = '*';
                if (qrvey_sync.every) {
                    dayStr = `1/${qrvey_sync.every}`;
                }

                let minuteStr = qrvey_sync.minute || 0;

                if (Array.isArray(qrvey_sync.hours) && qrvey_sync.hours.length > 0) {
                    let hourStr = '*';
                    const hourValues = (qrvey_sync.hours || []).map(h => h.value);
                    hourStr = hourValues.length ? hourValues.join(',') : '*';
                    return `${minuteStr} ${hourStr} ${dayStr} * ? *`;
                }else{
                    return `${minuteStr} ${dayStr} * ? *`;
                }
            }
            return '';
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.kiosk-team-register .free-trial-toggle .custom-control {
    margin-left: 0px !important;
    margin-top: 0px !important;
}
</style>
